import * as echarts from 'echarts/core'
import { BarChart, LineChart, HeatmapChart, PieChart } from 'echarts/charts'
import { CanvasRenderer } from 'echarts/renderers'
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent
} from 'echarts/components'

/**
 * Bootstrap ECharts dependencies
 * Ensure this function is invoked at least once before Echarts usage.
 */
echarts.use([
  // Major chart types
  BarChart,
  LineChart,
  HeatmapChart,
  PieChart,
  // Other components
  CanvasRenderer,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent
])
